




























import Cleave from 'cleave.js';

export default {
  props: {
    type: String,
    name: {
      type: String,
      required: true
    },
    disabled: Boolean,
    label: String,
    labelClass: [Object, String, Function, Array],
    inputClass: [Object, String, Function, Array],
    placeholder: String,
    layout: String,
    value: [String, Number],
    raw: {
      type: Boolean,
      default: true
    },
    oninput: Function,
    onchange: Function,
    formatter: {
      type: Object,
      required: false
    },
    helpBlockClass: [Object, String, Function, Array],
    helpBlock: String,
    inputmode: String,
    pattern: String
  },
  data: function() {
    const vm = this as any;
    const cleaveOptions = (vm.formatter && Object.keys(vm.formatter).length) 
      ? {...vm.formatter, onValueChanged: vm.handleCleaveChange}
      : {};

    return {
      valueType: typeof vm.value,
      cleave: null,
      cleaveOptions
    }
  },
  mounted() {
    const vm = this as any;
    if (vm.cleave) return;

    if (vm.formatter && Object.keys(vm.formatter).length) {
      vm.cleave = new Cleave(vm.$refs['pnetInput'], vm.cleaveOptions);
      vm.cleave.setRawValue(vm.value);
      if (vm.formatter.numeral) {
        vm.valueType = 'number';
      }
    } else {
      vm.$refs['pnetInput'].value = typeof vm.value === 'undefined' ? "" : vm.value;
    }
  },
  beforeDestroy() {
    const vm = this as any;
    if (!vm.cleave) return;

    vm.cleave.destroy();
    vm.cleave = null;
  },
  methods: {
    handleKeyEvent(eventName: string, ...args: any[]) {
      const vm = this as any;
      vm.$emit(eventName, ...args)
    },
    handleCleaveChange(e: any) {
      const vm = this as any;
      const value = vm.raw ? e.target.rawValue : e.target.value;
      vm.emitEvent('input', value);
    },
    handleEvent(event: Event, eventName: string) {
      const vm = this as any;
      if (event.target) {
        const tgt = event.target as HTMLInputElement;
        const val = tgt && tgt.value;
        
        if (vm.cleave) {
          return;
        }

        if (eventName === 'input' && vm.oninput) {
          vm.oninput(val);
        }
        if (eventName === 'change' && vm.onchange) {
          vm.onchange(val);
        }
        vm.emitEvent(eventName, val);
      }
    },
    emitEvent(eventName: string, val: string) {
      const vm = this as any;
      if (vm.valueType === 'number') {
        if (typeof val === 'undefined' || val === '') {
          vm.$emit(eventName, null);
        } else if (!Number.isNaN(Number(val))) {
          vm.$emit(eventName, Number(val).valueOf());
        }
        return;
      }

      vm.$emit(eventName, val);
    },
    isHorizontal(): boolean {
      const vm = this as any;
      return vm.layout === 'horizontal';
    },
    isVertical(): boolean {
      const vm = this as any;
      return vm.layout === 'vertical';
    },
    focus(): void {
      (this as any).$refs.pnetInput.focus();
    },
  },
  watch: {
    value: function(newVal: string|number) {
      const vm = this as any;
      if (vm.cleave) {
        if (vm.raw && newVal === vm.cleave.getRawValue() || !vm.raw && newVal === vm.cleave.getFormattedValue()) {
          return;
        }
        vm.cleave.setRawValue(newVal);
      } else {
        vm.$refs['pnetInput'].value = newVal === null || typeof newVal === 'undefined' ? '' : newVal;
      }
    }
  }
};

